const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Espelha a regra do backend (TransferProcessSendToCoordinationForm): vírgula, ponto e
// vírgula ou espaço separam os e-mails, e o repetido entra uma vez só.
export const parseCoordinationEmails = (value: string) => {
  const emails: string[] = [];

  value.split(/[,;\s]+/).forEach(email => {
    if (email && !emails.some(known => known.toLowerCase() === email.toLowerCase())) {
      emails.push(email);
    }
  });

  return {
    emails,
    invalid: emails.filter(email => !EMAIL_PATTERN.test(email)),
  };
};

// Junta o que foi digitado (ou colado) à lista já adicionada. Com algum endereço
// inválido nada entra, para o usuário corrigir o texto antes.
export const addCoordinationEmails = (current: string[], text: string) => {
  const { emails, invalid } = parseCoordinationEmails(text);

  if (invalid.length > 0) {
    return { emails: current, invalid };
  }

  const added = emails.filter(email => (
    !current.some(known => known.toLowerCase() === email.toLowerCase())
  ));

  return { emails: [...current, ...added], invalid };
};
